import moment from 'moment-timezone';
import store from '../store';

const formatters = {

  date(timestamp) {
    if (timestamp) {
      const truncated = timestamp.substring(0, 10);
      return moment(truncated, 'YYYY-MM-DD').format('DD.MM.YYYY');
    }
    return timestamp;
  },

  time(timestamp) {
    const timezone = store.getters.timezone;
    return formatters.timeInternal(timestamp, timezone);
  },

  dateTime(timestamp) {
    const timezone = store.getters.timezone;
    return formatters.dateTimeInternal(timestamp, timezone);
  },

  dateTimeWithFormat(timestamp, format) {
    const timezone = store.getters.timezone;
    return formatters.dateTimeInternal(timestamp, timezone, format);
  },

  dateTimeInternal(timestamp, timezone, format) {
    if (timestamp) {
      // no time data
      if (!timestamp.includes('T')) {
        return formatters.date(timestamp);
      }
      const t = moment(`${timestamp}Z`).tz(timezone);
      return format ? t.format(format) : t.format('DD.MM.YYYY HH:mm');
    }
    return timestamp;
  },

  timeInternal(timestamp, timezone) {
    if (timestamp) {
      // no time data
      if (!timestamp.includes('T')) {
        return '';
      }

      return moment(`${timestamp}Z`).tz(timezone).format('HH:mm:ss');
    }
    return timestamp;
  },

  amount(input) {
    if (Number.isNaN(Number.parseFloat(input))) {
      return input || '0.00';
    }
    return Number.parseFloat(input)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1\'');
  },

};

export default formatters;



// WEBPACK FOOTER //
// ./src/utils/formatters.js